import { render, staticRenderFns } from "./MainIndicators.vue?vue&type=template&id=f51642c6&scoped=true&"
import script from "./MainIndicators.vue?vue&type=script&lang=js&"
export * from "./MainIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51642c6",
  null
  
)

export default component.exports